export var AddressType = {
    Home: 0,
    Distribution: 1,
    Visitation: 2
};

export var PhoneType = {
    Home: 0,
    Mobile: 1,
    Work: 2,
    Holiday: 3
};

export var EmailType = {
    Public: 0,
    Private: 1,
    Internal: 2
};

export var UrlType = {
    NotSet: 0,
    Documents: 1,
    Photo: 2,
    HomePage: 3
};

export var Gender = {
    NotSet: 0,
    Man: 1,
    Woman: 2
};
